/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import { htmlSafe } from "@ember/template";
import { isPresent } from "@ember/utils";
import Component from "@glimmer/component";
export default class TitledLabelComponent extends Component {
  get noValueArgument() {
    return !("value" in this.args);
  }
  get valueIsPresent() {
    return isPresent(this.args.value);
  }
  get showBody() {
    return this.noValueArgument || this.valueIsPresent;
  }
  get value() {
    // @ts-expect-error the "value" arg can be undefined, we need to change this implementation
    return htmlSafe(this.args.value);
  }
}